import {
  BookMarked,
  Heart,
  LayoutDashboard,
  LogOut,
  Settings,
  UserCircle2,
} from "lucide-react";
import { Link } from "react-router-dom";

interface UserProfileDropdownProps {
  user: any; // Should be User | null
  handleLogout: () => void;
  setIsMenuOpen?: (isOpen: boolean) => void;
  isMobile?: boolean;
}

const UserProfileDropdown = ({
  user,
  handleLogout,
  setIsMenuOpen,
  isMobile = false,
}: UserProfileDropdownProps) => {
  const handleMobileItemClick = () => {
    if (setIsMenuOpen && isMobile) {
      setIsMenuOpen(false);
    }
  };

  if (isMobile) {
    return (
      <>
        <div className="flex items-center px-4 mb-3">
          <div className="flex-shrink-0">
            <div className="h-10 w-10 rounded-full bg-propertylk-blue text-white flex items-center justify-center">
              {user?.name?.charAt(0).toUpperCase() || "U"}
            </div>
          </div>
          <div className="ml-3">
            <div className="text-base font-medium text-gray-800">
              {user?.name || "User"}
            </div>
            <div className="text-sm font-medium text-gray-500">
              {user?.email || "No email"}
            </div>
          </div>
        </div>
        <Link
          to="/dashboard"
          className="flex items-center px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-propertylk-blue hover:bg-gray-50 transition duration-150 ease-in-out"
          onClick={handleMobileItemClick}
        >
          <LayoutDashboard className="mr-3 h-5 w-5 text-gray-400" />
          Dashboard
        </Link>
        <Link
          to="/favorites"
          className="flex items-center px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-propertylk-blue hover:bg-gray-50 transition duration-150 ease-in-out"
          onClick={handleMobileItemClick}
        >
          <Heart className="mr-3 h-5 w-5 text-gray-400" />
          Favorites
        </Link>
        <Link
          to="/saved-searches"
          className="flex items-center px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-propertylk-blue hover:bg-gray-50 transition duration-150 ease-in-out"
          onClick={handleMobileItemClick}
        >
          <BookMarked className="mr-3 h-5 w-5 text-gray-400" />
          Saved Searches
        </Link>
        <Link
          to="/dashboard/profile"
          className="flex items-center px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-propertylk-blue hover:bg-gray-50 transition duration-150 ease-in-out"
          onClick={handleMobileItemClick}
        >
          <Settings className="mr-3 h-5 w-5 text-gray-400" />
          Profile Settings
        </Link>
        <button
          className="flex items-center w-full text-left px-3 py-2 rounded-md text-base font-medium text-red-600 hover:bg-gray-50 transition duration-150 ease-in-out"
          onClick={() => {
            handleLogout();
            handleMobileItemClick();
          }}
        >
          <LogOut className="mr-3 h-5 w-5 text-red-400" />
          Sign out
        </button>
      </>
    );
  }

  return (
    <div className="relative group">
      <button className="p-1 rounded-full text-gray-500 hover:text-propertylk-blue focus:outline-none transition duration-150 ease-in-out">
        <UserCircle2 className="h-8 w-8" />
      </button>
      <div className="absolute right-0 w-48 mt-2 origin-top-right bg-white border border-gray-200 divide-y divide-gray-100 rounded-md shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-50">
        <div className="px-4 py-3">
          <p className="text-sm text-gray-700 truncate">
            {user?.name || "User"}
          </p>
          <p className="text-xs text-gray-500 truncate">
            {user?.email || "No email"}
          </p>
        </div>
        <div className="py-1">
          <Link
            to="/dashboard"
            className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
          >
            <LayoutDashboard className="mr-2 h-4 w-4 text-gray-400" />
            Dashboard
          </Link>
          <Link
            to="/favorites"
            className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
          >
            <Heart className="mr-2 h-4 w-4 text-gray-400" />
            Favorites
          </Link>
          <Link
            to="/saved-searches"
            className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
          >
            <BookMarked className="mr-2 h-4 w-4 text-gray-400" />
            Saved Searches
          </Link>
          <Link
            to="/dashboard/profile"
            className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
          >
            <Settings className="mr-2 h-4 w-4 text-gray-400" />
            Profile Settings
          </Link>
        </div>
        <div className="py-1">
          <button
            className="flex items-center w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
            onClick={handleLogout}
          >
            <LogOut className="mr-2 h-4 w-4 text-red-400" />
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserProfileDropdown;
